"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructSDK = exports.TwapSDK = void 0;
var analytics_1 = require("./analytics");
var consts_1 = require("./consts");
var lib_1 = require("./lib");
var orders_1 = require("./orders");
var utils_1 = require("./utils");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var analytics = new analytics_1.Analytics();
var analyticsCallback = {
    onApproveRequest: analytics.onApproveRequest.bind(analytics),
    onApproveSuccess: analytics.onApproveSuccess.bind(analytics),
    onApproveError: analytics.onApproveError.bind(analytics),
    onWrapRequest: analytics.onWrapRequest.bind(analytics),
    onWrapSuccess: analytics.onWrapSuccess.bind(analytics),
    onWrapError: analytics.onWrapError.bind(analytics),
    onCreateOrderRequest: analytics.onCreateOrderRequest.bind(analytics),
    onCreateOrderSuccess: analytics.onCreateOrderSuccess.bind(analytics),
    onCreateOrderError: analytics.onCreateOrderError.bind(analytics),
    onCancelOrderRequest: analytics.onCancelOrder.bind(analytics),
    onCancelOrderSuccess: analytics.onCancelOrderSuccess.bind(analytics),
    onCancelOrderError: analytics.onCanelOrderError.bind(analytics),
};
var TwapSDK = /** @class */ (function () {
    function TwapSDK(props) {
        this.analytics = analyticsCallback;
        this.config = props.config;
        analytics.onConfigChange(props.config);
        this.estimatedDelayBetweenChunksMillis = (0, lib_1.getEstimatedDelayBetweenChunksMillis)(this.config);
        this.orders = new orders_1.Orders(props.config);
    }
    //create order values
    TwapSDK.prototype.getAskParams = function (props) {
        return (0, lib_1.getAskParams)(this.config, props);
    };
    TwapSDK.prototype.getMaxChunks = function (typedSrcAmount, oneSrcTokenUsd, minChunkSizeUsd) {
        return (0, lib_1.getMaxPossibleChunks)(this.config, typedSrcAmount, oneSrcTokenUsd, minChunkSizeUsd);
    };
    TwapSDK.prototype.getChunks = function (maxChunks, isLimitPanel, customChunks) {
        return (0, lib_1.getChunks)(maxChunks, isLimitPanel, customChunks);
    };
    TwapSDK.prototype.getSrcTokenChunkAmount = function (srcAmount, chunks) {
        return (0, lib_1.getSrcChunkAmount)(srcAmount, chunks);
    };
    TwapSDK.prototype.getFillDelay = function (isLimitPanel, typedFillDelay) {
        return (0, lib_1.getFillDelay)(isLimitPanel, typedFillDelay);
    };
    TwapSDK.prototype.getOrderDuration = function (chunks, fillDelay, typedDuration) {
        return (0, lib_1.getDuration)(chunks, fillDelay, typedDuration);
    };
    TwapSDK.prototype.getDestTokenMinAmount = function (srcTokenChunkAmount, limitPrice, isMarketOrder, srcTokenDecimals) {
        return (0, lib_1.getDestTokenMinAmount)(srcTokenChunkAmount, limitPrice, isMarketOrder, srcTokenDecimals);
    };
    TwapSDK.prototype.getDestTokenAmount = function (srcAmount, limitPrice, srcTokenDecimals) {
        return (0, lib_1.getDestTokenAmount)(srcAmount, limitPrice, srcTokenDecimals);
    };
    TwapSDK.prototype.getOrderDeadline = function (currentTimeMillis, orderDuration) {
        return (0, lib_1.getDeadline)(currentTimeMillis, orderDuration);
    };
    // errors
    TwapSDK.prototype.getMaxFillDelayError = function (fillDelay, chunks) {
        return {
            isError: (0, utils_1.getTimeDurationMillis)(fillDelay) * chunks > consts_1.MAX_ORDER_DURATION_MILLIS,
            value: Math.floor(consts_1.MAX_ORDER_DURATION_MILLIS / chunks),
        };
    };
    TwapSDK.prototype.getOrderDurationError = function (duration) {
        return {
            isError: (0, utils_1.getTimeDurationMillis)(duration) > consts_1.MAX_ORDER_DURATION_MILLIS,
            value: consts_1.MAX_ORDER_DURATION_MILLIS,
        };
    };
    TwapSDK.prototype.getMinFillDelayError = function (fillDelay) {
        return {
            isError: (0, utils_1.getTimeDurationMillis)(fillDelay) < consts_1.MIN_FILL_DELAY_MILLIS,
            value: consts_1.MIN_FILL_DELAY_MILLIS,
        };
    };
    TwapSDK.prototype.getMinTradeSizeError = function (typedSrcAmount, oneSrcTokenUsd, minChunkSizeUsd) {
        return {
            isError: (0, bignumber_js_1.default)(oneSrcTokenUsd || 0)
                .multipliedBy(typedSrcAmount || 0)
                .isLessThan(minChunkSizeUsd),
            value: minChunkSizeUsd,
        };
    };
    TwapSDK.prototype.getMaxChunksError = function (chunks, maxChunks, isLimitPanel) {
        return {
            isError: !isLimitPanel && (0, bignumber_js_1.default)(chunks).isGreaterThan(maxChunks),
            value: maxChunks,
        };
    };
    TwapSDK.prototype.getOrders = function (account, signal) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.orders.getOrders(account, signal)];
            });
        });
    };
    return TwapSDK;
}());
exports.TwapSDK = TwapSDK;
var constructSDK = function (props) {
    return new TwapSDK(props);
};
exports.constructSDK = constructSDK;
